// extracted by mini-css-extract-plugin
export var container = "_4a-0";
export var disabled = "_4a-4";
export var fullWidth = "_4a-3";
export var lined = "_4a-1";
export var selected = "_4a-5";
export var tab = "_4a-2";